var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "f7-accordion-item",
        {
          staticClass: "accordionForm",
          attrs: { expanded: _vm.open },
          on: {
            "accordion:open": function ($event) {
              _vm.openedAccordion = true
            },
            "accordion:opened": function ($event) {
              _vm.openedFinishedAccordion = true
            },
            "accordion:close": function ($event) {
              _vm.openedAccordion = _vm.openedFinishedAccordion = false
            },
          },
        },
        [
          _vm.toggleActive
            ? _c("f7-accordion-toggle", { staticClass: "accordionToggle" }, [
                _c(
                  "div",
                  {
                    staticClass: "form-group row justify-content-between",
                    class: _vm.titleClassContainer,
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "col-sm-auto titleAccordion",
                        class: [
                          _vm.isTitleUpperCase ? "text-uppercase" : "",
                          _vm.isTitleBold ? "font-weight-bold" : "",
                          _vm.titleClass,
                        ],
                      },
                      [
                        _vm._v(
                          "\n          " + _vm._s(_vm.title) + "\n          "
                        ),
                        _vm.star
                          ? _c("span", { staticClass: "color-red" }, [
                              _vm._v(" *"),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.openedAccordion && _vm.showArrow
                          ? _c("i", {
                              staticClass:
                                "ml-2 fa-light fa-chevron-down color-var-actionButtonColorBlue",
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.openedAccordion && _vm.showArrow
                          ? _c("i", {
                              staticClass:
                                "ml-2 fa-light fa-chevron-right color-var-actionButtonColorBlue",
                            })
                          : _vm._e(),
                      ]
                    ),
                    _vm._v(" "),
                    !_vm.openedAccordion || _vm.keepSummaryCenter
                      ? _vm._t("summaryCenter")
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.openedAccordion || _vm.keepSummary
                      ? _vm._t("summary")
                      : _vm._e(),
                  ],
                  2
                ),
              ])
            : _c("div", { staticClass: "w-fit-content" }, [
                _c(
                  "div",
                  { staticClass: "form-group row justify-content-start" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "col-sm-auto titleAccordion",
                        class: [
                          _vm.isTitleUpperCase ? "text-uppercase" : "",
                          _vm.isTitleBold ? "font-weight-bold" : "",
                        ],
                      },
                      [
                        _vm._v(
                          "\n          " + _vm._s(_vm.title) + "\n        "
                        ),
                      ]
                    ),
                  ]
                ),
              ]),
          _vm._v(" "),
          _c(
            "f7-accordion-content",
            {
              class: { accordionContentExpended: _vm.openedFinishedAccordion },
            },
            [_vm._t("default")],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }